/**
 * tint → Tailwind 类映射。
 * 把 ModuleTint（模块色键）转成背景/文字色，对应 iOS 的
 * EncyclopediaModule.tint 与 EntryIcon.categoryColor。
 */

import type { EncyclopediaEntry } from '@/core/models';
import {
  entryKindFallbackTint,
  moduleTintForEntry,
  type ModuleTint,
} from '@/core/moduleCatalog';

// 注意：Tailwind 需要静态类名才能被 JIT 识别，这里穷举所有 tint 的类。
const bgClasses: Record<ModuleTint, string> = {
  ocean: 'bg-ocean/15',
  teal: 'bg-teal-500/15',
  indigo: 'bg-indigo-500/15',
  sage: 'bg-sage/15',
  plum: 'bg-plum/15',
  amber: 'bg-amber/15',
  orange: 'bg-orange-500/15',
  brown: 'bg-amber-700/15',
};

const textClasses: Record<ModuleTint, string> = {
  ocean: 'text-ocean',
  teal: 'text-teal-600',
  indigo: 'text-indigo-600',
  sage: 'text-sage',
  plum: 'text-plum',
  amber: 'text-amber',
  orange: 'text-orange-600',
  brown: 'text-amber-800',
};

function tintForEntry(entry: Pick<EncyclopediaEntry, 'kind' | 'topicID'>): ModuleTint {
  return moduleTintForEntry(entry.topicID) ?? entryKindFallbackTint[entry.kind];
}

export const TintBackground = {
  forTint: (tint: ModuleTint) => bgClasses[tint],
  forEntry: (entry: Pick<EncyclopediaEntry, 'kind' | 'topicID'>) =>
    bgClasses[tintForEntry(entry)],
};

export const TintText = {
  forTint: (tint: ModuleTint) => textClasses[tint],
  forEntry: (entry: Pick<EncyclopediaEntry, 'kind' | 'topicID'>) =>
    textClasses[tintForEntry(entry)],
};
